import tanks from '@components/competitions/levels/tekyehmajazi/assets/images/t0/tanks.webp';
import winner from '@components/competitions/levels/tekyehmajazi/assets/images/t0/winner.webp';
import SpecialComponent from '@components/competitions/levels/tekyehmajazi/SpecialComponent';
import {useCompetitionTekyehmajaziContext} from '@context/CompetitionTekyehmajaziContext';
import {Box} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';

const DefaultComponent: React.FC = () =>
	<Box className="flex flex-col w-full gap-y-5 items-center justify-center">
		<div className="w-9/12">
			<img src={tanks} alt={'content'} className="w-full"/>
		</div>
		<div className="w-4/12 mt-10">
			<Link to={`/network/35`}>
				<img src={winner} alt="info" className={'w-full'}/>
			</Link>
		</div>
	</Box>;
	
const allowedHours: number[] = [22];
// const allowedHours: number[] = [22];
// const minutes: number[] = [15, 25, 35];
const allowedDays: number[] = [10, 11, 12, 15, 17, 27, 28, 29];
// const allowedDays: number[] = [13];

export const QuestionsComponent: React.FC = () => {
	const [isActive, setIsActive] = useState(false);
	const [hasTimePassed, setHasTimePassed] = useState(false);
	const navigate = useNavigate();
	const {
		setMission
	} = useCompetitionTekyehmajaziContext();
	useEffect(() => {
		const checkTime = () => {
			const now = new Date();
			const currentDate = now.getDate();
			const currentHours = now.getHours();
			const currentMinutes = now.getMinutes();
			
			const isSpecialDate = allowedDays.includes(currentDate);
			const isAllowedHour = allowedHours.includes(currentHours);
			// const lastMinute = Math.max(...minutes); // Get the last allowed minute
			// New logic: Minutes must be between 0 and (last minute + 5)
			// const isAllowedMinutes = currentMinutes >= 0 && currentMinutes <= lastMinute + 10;
			// const timeExceeded = currentMinutes > lastMinute + 5; // If current time is past last allowed range
			const isAllowedMinutes = currentMinutes >= 0 && currentMinutes <= 50;
			const timeExceeded = currentMinutes > 50; // If current time is past last allowed range
			
			setIsActive(isSpecialDate && isAllowedHour && isAllowedMinutes);
			setHasTimePassed(isSpecialDate && isAllowedHour && timeExceeded);
		};
		
		// Run check on mount
		checkTime();
		
		// Check every 15 seconds
		const interval = setInterval(checkTime, 15000);
		
		return () => clearInterval(interval);
	}, []);
	
	// Navigate when time has passed
	useEffect(() => {
		if (hasTimePassed) {
			// navigate('/competition/tekyehmajazi');
		}
	}, [hasTimePassed, navigate]);
	
	return isActive ? (
		// <SpecialComponent allowedDays={allowedDays} allowedHours={allowedHours} minutes={minutes}/>
		<SpecialComponent allowedDays={allowedDays} allowedHours={allowedHours}/>
	) : (
		<DefaultComponent/>
	);
};
